import { LabradorComponent } from '@/types/component';
import { LabradorArticle } from 'base/components/labrador/Article';

export const HantLabradorArticle: LabradorComponent = (props) => {
  return <LabradorArticle hide={{ badge: false }} {...props} />;
};
